import { recieveTags } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadTags = () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/tags/get_options/')

        if (data) {
            dispatch(recieveTags(data));
        }
    } catch (error) {
        console.error('Unable to load tags!', error)
    }
};
